<template>
    <span class="embed-content-item">
        <Component v-if="component" :is="component.is" v-bind="component.bindings"></Component>
    </span>
</template>

<script>
import EmbedAudio from "@/components/embed/EmbedAudio.vue"; // Required
import EmbedSoundslice from "@/components/embed/EmbedSoundslice.vue"; // Required
import EmbedSpotifyAlbum from "@/components/embed/EmbedSpotifyAlbum.vue"; // Required
import EmbedSpotifyPlaylist from "@/components/embed/EmbedSpotifyPlaylist.vue"; // Required
import EmbedYoutube from '@/components/embed/EmbedYoutube.vue'; // Required
import VideoGeneralCloudfront from '@/components/video/VideoGeneralCloudfront.vue'; // Required

export default {
    name: 'EmbedContentItem',
    props: {
        contentItem: {
            required: true,
            type: Object,
        }
    },
    components: {
        EmbedAudio,
        EmbedSoundslice,
        EmbedSpotifyAlbum,
        EmbedSpotifyPlaylist,
        EmbedYoutube,
        VideoGeneralCloudfront,
    },
    computed: {
        component () {
            if (!this.contentItem || !this.contentItem.type) return null;
            const type = this.contentItem.type;
            if (type === 'spotify_playlist' || type === 'spotify_user_playlist' || type === 'spotify_curated_playlist' || type === 'spotify_general_playlist') {
                return {
                    is: 'EmbedSpotifyPlaylist',
                    bindings: {
                        idPlaylist: this.contentItem.spotify_playlist_id
                    }
                };
            } else if (type === 'spotify_album') {
                return {
                    is: 'EmbedSpotifyAlbum',
                    bindings: {
                        idAlbum: this.contentItem.spotify_album_id
                    }
                };
            } else if (type === 'youtube') {
                return {
                    is: 'EmbedYoutube',
                    bindings: {
                        idYoutube: this.contentItem.youtube_id
                    }
                };
            } else if (type === 'video') {
                return {
                    is: 'VideoGeneralCloudfront',
                    bindings: {
                        src: this.contentItem.video_src,
                    }
                };
            } else if (type === 'soundslice_score') {
                return {
                    is: 'EmbedSoundslice',
                    bindings: {
                        idSoundslice: this.contentItem.soundslice_score_id,
                        type: 'score'
                    }
                };
            } else if (type === 'soundslice_slice') {
                return {
                    is: 'EmbedSoundslice',
                    bindings: {
                        idSoundslice: this.contentItem.soundslice_slice_id,
                        type: 'slice'
                    }
                };
            } else if (type === 'audio') {
                return {
                    is: 'EmbedAudio',
                    bindings: {
                        audioSrc: this.contentItem.audio_src,
                    }
                };
            }
            return null;
        }
    },
};

</script>
